import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=52cf93fb&lang=less&scoped=true"

import exportComponent from "D:\\wenlvVue\\yijiangshandao_v3\\yijiangshandao\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52cf93fb"]])

export default __exports__